import { render, staticRenderFns } from "./SettingsPassword.vue?vue&type=template&id=40bbd8af&scoped=true"
import script from "./SettingsPassword.vue?vue&type=script&lang=js"
export * from "./SettingsPassword.vue?vue&type=script&lang=js"
import style0 from "./SettingsPassword.vue?vue&type=style&index=0&id=40bbd8af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbd8af",
  null
  
)

export default component.exports